<template>
    <div class="main-chart">
        <div id="chart">
            <apexchart :series="series" :options="options" :height="height"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    name: "AreaChart",
    props: {
        series: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        height: {
            type: Number,
            required: true
        }
    },
}
</script>

<style scoped>

</style>